import { motion } from "framer-motion";
import { BadgeCheck, Search, MoreVertical, ExternalLink, Paperclip, Mic, Signal, Wifi, BatteryMedium } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { PRODUCTS } from "@/config";

const POSTS = [PRODUCTS[0], PRODUCTS[1], PRODUCTS[2]];

export default function PhoneMockup() {
    return (
        <div
            data-testid="hero-phone-mockup"
            className="relative w-[288px] rounded-[2.9rem] bg-ink p-[10px] shadow-[0_50px_90px_-24px_rgba(11,18,32,0.5)] ring-1 ring-white/10 sm:w-[320px]"
        >
            <div className="relative overflow-hidden rounded-[2.4rem] bg-[#E9EEF4]">
                {/* Status bar */}
                <div className="relative flex items-center justify-between px-6 pt-3.5">
                    <span className="text-[10px] font-bold text-ink/80">9:41</span>
                    <div className="absolute left-1/2 top-2.5 h-[18px] w-20 -translate-x-1/2 rounded-full bg-ink" />
                    <div className="flex items-center gap-1 text-ink/70">
                        <Signal className="h-3 w-3" />
                        <Wifi className="h-3 w-3" />
                        <BatteryMedium className="h-3.5 w-3.5" />
                    </div>
                </div>

                {/* Telegram header */}
                <div className="mt-3 flex items-center gap-2.5 border-b border-ink/5 bg-white/95 px-3.5 py-2.5 backdrop-blur">
                    <LogoMark className="h-8 w-8" idSuffix="phone" />
                    <div className="min-w-0 flex-1 leading-tight">
                        <div className="flex items-center gap-1">
                            <span className="truncate text-[13px] font-bold text-ink">Sconti Incredibili</span>
                            <BadgeCheck className="h-3.5 w-3.5 shrink-0 fill-telegram text-white" />
                        </div>
                        <span className="text-[10px] font-medium text-slate-400">Offerte ogni giorno</span>
                    </div>
                    <Search className="h-4 w-4 text-slate-400" />
                    <MoreVertical className="h-4 w-4 text-slate-400" />
                </div>

                {/* Chat body */}
                <div className="min-h-[392px] space-y-3 px-3 py-4" data-testid="phone-chat-body">
                    {POSTS.map((p, i) => (
                        <motion.div
                            key={p.id}
                            initial={{ opacity: 0, y: 18, scale: 0.97 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            transition={{ delay: 1 + i * 0.4, duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
                            data-testid={`phone-message-${p.id}`}
                            className="relative max-w-[94%] rounded-2xl rounded-tl-md bg-white px-3.5 py-2.5 shadow-[0_2px_10px_-4px_rgba(11,18,32,0.12)]"
                        >
                            <div className="flex items-center gap-1 text-[10px] font-bold text-telegram-deep">
                                Sconti Incredibili
                                <BadgeCheck className="h-3 w-3 fill-telegram text-white" />
                            </div>
                            <p className="mt-1 text-[12.5px] font-semibold leading-snug text-ink">{p.name}</p>
                            <div className="mt-1.5 flex items-baseline gap-2">
                                <span className="text-[11px] text-slate-400 line-through">{p.oldPrice}</span>
                                <span className="text-[15px] font-extrabold tracking-tight text-ink">{p.price}</span>
                                <span className="rounded-md bg-flame/10 px-1.5 py-0.5 font-mono text-[10px] font-bold text-flame">
                                    {p.discount}
                                </span>
                            </div>
                            <div className="mt-2.5 flex w-full items-center justify-center gap-1.5 rounded-lg bg-telegram py-2 text-[10px] font-bold tracking-wider text-white">
                                VEDI OFFERTA
                                <ExternalLink className="h-3 w-3" />
                            </div>
                            <div className="mt-1 flex items-center justify-end gap-1 text-[9px] text-slate-400">
                                {p.time}
                                <BadgeCheck className="h-2.5 w-2.5 rotate-12 text-telegram" />
                            </div>
                        </motion.div>
                    ))}
                </div>

                {/* Input bar */}
                <div className="flex items-center gap-2.5 bg-white/95 px-3.5 py-2.5 backdrop-blur">
                    <Paperclip className="h-4 w-4 text-slate-400" />
                    <span className="flex-1 rounded-full bg-slate-100 px-3.5 py-1.5 text-[11px] text-slate-400">
                        Scrivi un messaggio…
                    </span>
                    <Mic className="h-4 w-4 text-telegram" />
                </div>
            </div>
        </div>
    );
}
